{
  "eventDetails": "Détails de l'événement",
  "helpContentBodyText": "Affiche les 10 événements les plus récents signalés par cet appareil.\n\nAffichez les rapports de différents capteurs en appuyant/cliquant dessus dans Capteurs de rapport.\n\nAffichez les événements plus anciens et plus récents en appuyant/cliquant sur « plus ancien » et « plus récent ».",
  "linkTo": "Événements",
  "noDataForSensorWithSensorName": "Aucune donnée pour le capteur {{sensorName}}",
  "noOlderEventsFoundForThisDevice": "Aucun événement plus ancien n'a été trouvé pour cet appareil.",
  "reportingSensors": "Capteurs de rapport",
  "sensorReport": "Rapport du capteur {{sensorName}}",
  "subheader": "Cliquez/appuyez pour inspecter",
  "title": "Historique des événements"
}
